import {authorized} from "./ApiClient";
import {OrderStatus, OrderViewModel} from "./models";

// Every customer's orders (SiteAdmin). Refunds are made in Stripe's or PayPal's dashboard; the API revokes the license.
export const OrdersApi = {
    getAll: (status?: OrderStatus) => authorized<OrderViewModel[]>('GET', status ? `/order?status=${encodeURIComponent(status)}` : '/order')
};
